<mat-card class="mat-card--widget">
  <mat-card-content>
    <div class="container">
      <div class="row">
        <form [formGroup]="form">
          <div class="col s12 m9 l10">
            <mat-form-field>
              <input
                matInput
                placeholder="Search My Carts"
                formControlName="searchText"
                (keyup)="search$.next($event)"
              />
            </mat-form-field>
          </div>
          <div class="col s12 m3 l2">
            <button class="btn btn-primary" (click)="refreshCart()">Refresh</button>
          </div>
        </form>
      </div>
    </div>
  </mat-card-content>
</mat-card>
